import { http } from "@/lib/http";
export function fetchMainServices() {
  return http.get("/api/services/getMain").then((res) => res.data);
}
export function fetchMoreServices() {
  return http.get("/api/services/getMore").then((res) => res.data);
}
export function fetchService(id) {
  return http.get(`/api/services/${id}`).then((res) => res.data);
}
export function addService(payload) {
  return http.post("/api/services/add", payload).then((res) => res.data);
}
export function updateService(id, payload) {
  return http
    .put(`/api/services/update/${id}`, payload)
    .then((res) => res.data);
}
export function deleteService(id) {
  return http.delete(`/api/services/delete/${id}`).then((res) => res.data);
}
const SERVICES_LAYOUT_ID = "5fbcacfad6cbba0a2a6abb6b";
export function fetchServicesLayout() {
  return http.get("/api/services_layout/get").then((res) => res.data);
}
export function updateServicesLayout({ rows, columns }) {
  return http
    .put(`/api/services_layout/update/${SERVICES_LAYOUT_ID}`, { rows, columns })
    .then((res) => res.data);
}
